import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import { MainContext, useContext } from '../Main/MainContext'
import { api, server, prefix, endpoints } from '../Main/Api';

export default function TedaviProtokolu(props) {

  const { user, token } = useContext(MainContext)
  const { t } = useTranslation()
  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false)
  const [ara, setAra] = useState()
  const [sayfa, setSayfa] = useState(1)
  const [sonSayfa, setSonSayfa] = useState(1)
  const [receteler, setReceteler] = useState([])

  const { recete, setRecete } = props;

  const afterOpenModal = () => {
    listele()
  }

  const closeModal = () => {
    setOpen(false)
  }

  const listele = () => {
    setLoading(true)
    const url = server + prefix + endpoints.recete_listele;
    api.request(url, "GET", {
      ara,
      page: sayfa,
    }, {
      "Authorization": "Bearer " + token
    }).then((response) => {
      const { data: responseData } = response;

      const { sayfa, son_sayfa } = responseData;

      setSonSayfa(son_sayfa);
      setSayfa(sayfa)

      setReceteler(responseData.data);
      setLoading(false)
    }).catch((err) => {
      setLoading(false)
    })
  }

  useEffect(() => {
    Modal.setAppElement('#root');
  }, [])

  const araFnc = (e) => {
    if (e.key == 'Enter') {
      listele()
    }
  }

  const modalAc = () => {
    setOpen(true)
  }

  return (
    <div>
      <div className="form-group">
        <label htmlFor="tedavi_protokolu"><small className="text-danger">*</small> {t('tedavi_protokolu')}</label>
        <input id="tedavi_protokolu" type="text" className="form-control" value={recete != null ? recete.recete_adi : ""} readOnly onClick={() => modalAc()} />
      </div>

      <Modal
        isOpen={open}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal">

        <h3>{t('tedavi_protokolleri')}</h3>

        {
          loading ?
            <>
              <div className="text-center mt-5">
                <i className="fas fa-spinner fa-spin fa-2x mb-2"></i>
                <p>{t("yukleniyor...")}</p>
              </div>
            </>
            :
            <>
              <input type="text" value={ara} onKeyDown={araFnc} onChange={(e) => setAra(e.target.value)} placeholder={t('recete_ara_plc')} className="form-control" />
              <div className="table-responsive mt-2">
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{t('tp_adi')}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      receteler.map((item, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item.recete_adi}</td>
                          <td>
                            <button onClick={() => { setRecete(item); setOpen(false) }} className="btn btn-outline-success btn-sm">
                              <i className="fas fa-check"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            </>
        }

      </Modal>
    </div>
  )
}


const customStyles = {
  content: {
    minWidth: '35%',
    minHeight: '70%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};